import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const SvgContainer = styled.svg`
  height: ${props => (props.size ? props.size + "px" : "18px")};
  width: ${props => (props.size ? props.size + "px" : "18px")};
  path {
    fill: ${props => (props.color ? props.color : Variables.colors.black)};
  }
`;
